export const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.15, // o 1 para que cada botón aparezca 1 segundo después del anterior
    },
  },
};

export const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
};
